const PASSWORD_CIPHER_KEY = 'kiyuukai';
export const PASSWORD_HINT = '代表の法人名は？(8文字)';
export const PASSWORD_CIPHER_VERSION = 'v1-xor-browser';

function toBase64(bytes) {
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function randomNonceHex(size = 16) {
  const bytes = new Uint8Array(size);
  crypto.getRandomValues(bytes);
  return Array.from(bytes).map((b) => b.toString(16).padStart(2, '0')).join('');
}

function fromBase64(value) {
  const binary = atob(value);
  const out = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    out[i] = binary.charCodeAt(i);
  }
  return out;
}

export function encryptPasswordOnClient(plainText) {
  const nonce = randomNonceHex();
  const source = new TextEncoder().encode(plainText);
  const key = new TextEncoder().encode(`${PASSWORD_CIPHER_KEY}:${nonce}`);
  const out = new Uint8Array(source.length);

  for (let i = 0; i < source.length; i += 1) {
    out[i] = source[i] ^ key[i % key.length];
  }

  return {
    passwordEncrypted: toBase64(out),
    passwordNonce: nonce,
    passwordHint: PASSWORD_HINT,
    passwordCipherVersion: PASSWORD_CIPHER_VERSION,
  };
}

export function verifyPasswordCipherKey(inputKey) {
  return String(inputKey || '') === PASSWORD_CIPHER_KEY;
}

export function decryptPasswordOnClient(payload, inputKey) {
  if (!verifyPasswordCipherKey(inputKey)) {
    throw new Error('invalid-cipher-key');
  }
  if (!payload?.passwordEncrypted || !payload?.passwordNonce) {
    throw new Error('missing-password-data');
  }

  const source = fromBase64(payload.passwordEncrypted);
  const key = new TextEncoder().encode(`${PASSWORD_CIPHER_KEY}:${payload.passwordNonce}`);
  const out = new Uint8Array(source.length);

  for (let i = 0; i < source.length; i += 1) {
    out[i] = source[i] ^ key[i % key.length];
  }

  return new TextDecoder().decode(out);
}
